module.exports = {
	"_from": "crossfilter2@^1.4.6",
	"_id": "crossfilter2@1.4.7",
	"_inBundle": false,
	"_integrity": "sha512-9swxPbMBSO4AjednWnEwlidQQxjYllWmnKkY1hs+QRxbAjsO6QsUYf3GkTDA/KLO1K0FlbWvmMsKxTXZVqp1vw==",
	"_location": "/crossfilter2",
	"_phantomChildren": {},
	"_requested": {
		"type": "range",
		"registry": true,
		"raw": "crossfilter2@^1.4.6",
		"name": "crossfilter2",
		"escapedName": "crossfilter2",
		"rawSpec": "^1.4.6",
		"saveSpec": null,
		"fetchSpec": "^1.4.6"
	},
	"_requiredBy": [
		"/dc"
	],
	"_resolved": "https://registry.npmjs.org/crossfilter2/-/crossfilter2-1.4.7.tgz",
	"_shasum": "ab9372b46f36fb7b5da25f725b1e2838f2877987",
	"_spec": "crossfilter2@^1.4.6",
	"_where": "/Users/h12345jack/Documents/projects/bilibili-Visualization/node_modules/dc",
	"author": {
		"name": "Mike Bostock",
		"url": "http://bost.ocks.org/mike"
	},
	"bugs": {
		"url": "https://github.com/crossfilter/crossfilter/issues"
	},
	"bundleDependencies": false,
	"contributors": [
		{
			"name": "Jason Davies",
			"url": "http://www.jasondavies.com/"
		}
	],
	"dependencies": {
		"lodash.result": "^4.4.0"
	},
	"deprecated": false,
	"description": "Fast multidimensional filtering for coordinated views.",
	"devDependencies": {
		"browserify": "^13.0.0",
		"d3": "3.5",
		"eslint": "2.10.2",
		"package-json-versionify": "1.0.2",
		"semver": "^5.3.0",
		"sinon": "^4.0.2",
		"uglify-js": "2.4.0",
		"vows": "0.7.0"
	},
	"eslintConfig": {
		"env": {
			"browser": true,
			"node": true
		},
		"globals": {
			"Uint8Array": true,
			"Uint16Array": true,
			"Uint32Array": true
		},
		"extends": "eslint:recommended"
	},
	"files": [
		"src",
		"index.js",
		"index.d.ts",
		"crossfilter.js",
		"crossfilter.min.js"
	],
	"homepage": "https://crossfilter.github.io/crossfilter/",
	"keywords": [
		"analytics",
		"visualization",
		"crossfilter"
	],
	"license": "Apache-2.0",
	"main": "./index.js",
	"maintainers": [
		{
			"name": "Gordon Woodhull",
			"url": "https://github.com/gordonwoodhull"
		},
		{
			"name": "Tanner Linsley",
			"url": "https://github.com/tannerlinsley"
		},
		{
			"name": "Ethan Jewett",
			"url": "https://github.com/esjewett"
		}
	],
	"name": "crossfilter2",
	"repository": {
		"type": "git",
		"url": "git+ssh://git@github.com/crossfilter/crossfilter.git"
	},
	"scripts": {
		"benchmark": "node test/benchmark.js",
		"build": "browserify index.js -t package-json-versionify --standalone crossfilter -o crossfilter.js && uglifyjs --compress --mangle --screw-ie8 crossfilter.js -o crossfilter.min.js",
		"clean": "rm -f crossfilter.js crossfilter.min.js",
		"test": "vows --verbose && eslint src/"
	},
	"types": "./index.d.ts",
	"unpkg": "./crossfilter.min.js",
	"version": "1.4.7"
};


//////////////////
// WEBPACK FOOTER
// ./~/crossfilter2/package.json
// module id = 881
// module chunks = 0